/**
 * Notification types for the header bell. The bell is a single shared store
 * written by the task layer (Phase 2) and the messaging layer (Phase 3); the
 * `MESSAGE_MENTION` type is reserved here so the enum is stable across phases.
 * Stored as `VarChar` so new types never need an enum migration.
 */
export const NOTIFICATION_TYPES = [
  'TASK_ASSIGNED',
  'TASK_DUE_SOON',
  'TASK_STATUS_CHANGED',
  'TASK_COMMENT',
  'TASK_MENTION',
  'MESSAGE_MENTION',
  // Phase 5 — CO asks an officer for a status update on a specific task,
  // officer posts an update back (asked or voluntary).
  'TASK_UPDATE_REQUESTED',
  'TASK_UPDATE_POSTED',
] as const;
export type NotificationType = (typeof NOTIFICATION_TYPES)[number];
